import { ReactElement } from 'react';
const LoadingIndicator = (): ReactElement => {
  return <main className='p-4 md:p-10 mx-auto max-w-9xl' data-sentry-component="LoadingIndicator" data-sentry-source-file="loadingIndicator.tsx">
      <div className='loading-skeleton flash-animation'>
        <div className='skeleton-header'></div>
        <div className='skeleton-body'></div>
      </div>
    </main>;
};
export default LoadingIndicator;